import { cva } from 'class-variance-authority';

export const card = cva('bg-color-background-base rounded transition-all', {
  variants: {
    hasAutoSeparation: {
      true: 'divide-color-grey divide-y',
      false: '',
    },
    layout: {
      outlined: 'border-color-grey border',
      default: 'shadow-xs',
    },
    isActive: {
      true: 'border-l-color-primary border-l-4',
      false: '',
    },
  },
  defaultVariants: { hasAutoSeparation: false, layout: 'default', isActive: false },
});
